import styled from 'styled-components';

export const UpldsFiles = styled.div`
  background-color: #252525;
  border-radius: 4px;
  overflow: hidden;
  margin-top: 10px;
`;
export const UploadedFilesBody = styled.div`
  height: 266px;
  overflow-y: auto;
  text-align: center;
  padding: 10px;
  embed {
    width: 100%;
    height: 100%;
  }
`;
export const UploadedFilesFtr = styled.div`
  background-color: #252525;
  border-radius: 0 0 4px 4px;
  border-top: 1px #383838 solid;
  padding: 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
export const BtnApprove = styled.button`
  display: inline-block;
  background: linear-gradient(160.78deg, #53b2fe -83.81%, #065af3 163.56%);
  outline: 0;
  border: 0;
  cursor: pointer;
  border-radius: 4px;
  padding: 6px 16px;
  font-family: 'Lato';
  font-size: 12px;
  font-weight: 900;
  color: #fff;
  text-transform: uppercase;
  margin-left: 10px;
  ${p =>
    p.isDisabled &&
    `
        background: #DADADA;
        pointer-events: none;
        box-shadow: none;
    `}
`;

export const BtnUploadAgain = styled.p`
  font-size: 12px;
  line-height: 14px;
  color: #008cff;
  cursor: pointer;
`;
